module.exports = __webpack_public_path__ + "img/eu.7b4534d2.svg";